var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"home"},[_c('Booking')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }